// extracted by mini-css-extract-plugin
export default {"copyContents":"vBufRh2Kxr7YplYrZq5O"};